import { LogOutIcon } from "lucide-react";
import { useRecoilState } from "recoil";
import {
  BoTokenAtom,
  BoUserTypeAtom,
  CounselEnrollAtom,
  CounselProgressAtom,
  UserObjectIdAtom,
} from "src/Atoms";
import { UserPortrait } from "src/common/Common";
import { clearLocalStorage } from "src/common/Util";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/v1/ui/dropdown-menu";

export const DropdownMenuAvatar = ({ userInfo }) => {
  const [boToken, setBoToken] = useRecoilState(BoTokenAtom);
  const [boUserType, setBoUserType] = useRecoilState(BoUserTypeAtom);
  const [userObjectId, setUserObjectId] = useRecoilState(UserObjectIdAtom);
  const [enrolledCount, setEnrolledCount] = useRecoilState(CounselEnrollAtom);
  const [progressCount, setProgressCount] = useRecoilState(CounselProgressAtom);
  const onLogout = () => {
    setBoToken({});
    setBoUserType("");
    setUserObjectId("");
    setEnrolledCount(0);
    setProgressCount(0);
    clearLocalStorage();
    //window.location.reload();  // 이건 localStorage["bo-uid"]를 지우기 위해서 불러줌
    window.location.href = "/";
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <UserPortrait userInfo={userInfo} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white">
        <DropdownMenuItem className="font-medium">
          <LogOutIcon className="size-4" />
          <div onClick={onLogout}>로그아웃</div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
